//
const ALMA = {
    name: 'ALMA $length $offset $sigma',
    side: 'onchart',
    type: 'ALMA',
    data: [],
    settings: {
        length: 10,
        offset: 0.9,
        sigma: 5,
        applyto: `close`,
        lineWidth: 0.75,
        color: '#559de0ff',
    },
};
//
const Area51 = {
    name: `Area51`,
    type: 'Area51',
    data: [],
    settings: {
        color: '#2fd68fff',
    },
};
//
const ATR = {
    name: 'ATR $length',
    side: 'offchart',
    type: 'ATR',
    data: [],
    settings: {
        length: 15,
        lineWidth: 0.75,
        color: '#e52468ff',
    },
};
//
const ATRp = {
    name: 'ATR $percentage % $length',
    side: 'offchart',
    type: 'ATRp',
    data: [],
    settings: {
        length: 15,
        percentage: 100,
        applyto: `close`,
        lineWidth: 0.75,
        color: '#890c00ff',
    },
};
//
const BB = {
    name: 'BB $length $stddev',
    side: 'onchart',
    type: 'BB',
    data: [],
    settings: {
        length: 21,
        stddev: 2,
        showMid: true,
        lineWidth: 0.75,
        borderColor: '#2cc6c9',
        middleColor: '#2cc6c9',
        backColor: '#2cc6c911',
    },
};
//
const BBW = {
    name: 'BBW $length $stddev',
    side: 'offchart',
    type: 'BBW',
    data: [],
    settings: {
        length: 21,
        stddev: 2,
        lineWidth: 0.75,
        color: '#2cc6c9ab',
    },
};
//
const CCI = {
    name: 'CCI $length',
    side: 'offchart',
    type: 'CCI',
    data: [],
    settings: {
        upper: 100,
        lower: -100,
        length: 21,
        lineWidth: 0.75,
        color: '#e28a3dee',
        backColor: '#e28a3d11',
        bandColor: '#aaaaaa',
    },
};
//
const CMO = {
    name: 'CMO $length',
    side: 'offchart',
    type: 'CMO',
    data: [],
    settings: {
        length: 10,
        lineWidth: 0.75,
        color: '#559de0ff',
    },
};
//
const COG = {
    name: 'COG $length',
    side: 'offchart',
    type: 'COG',
    data: [],
    settings: {
        length: 10,
        lineWidth: 0.75,
        color: '#559de0ff',
    },
};
//
const DHistogram = {
    name: 'DHistogram',
    side: 'offchart',
    type: 'DHistogram',
    data: [],
    settings: {
        histWidth: 4,
        thresholdSize: 0,
        posColor: '#35a776ff',
        negColor: '#e54150ff',
    },
};
///////////////////////////////////////////////////////////////////////
const DMI = {
    name: 'DMI $length $smooth',
    side: 'offchart',
    type: 'DMI',
    data: [],
    settings: {
        length: 15,
        smooth: 15,
        lineWidth: 0.75,
        colors: ['#ef1360', '#3782f2', '#f48709'],
    },
};
//
const EMA = {
    name: `EMA $length`,
    side: 'onchart',
    type: 'EMA',
    data: [],
    settings: {
        length: 50,
        applyto: `close`,
        color: '#890c00ff',
        lineWidth: 0.75,
    },
};
/////////////////////////////////////////////////////////////
const Histogram = {
    name: `Histogram`,
    type: 'Histogram',
    data: [],
    settings: {
        lineWidth: 2,
    },
};

const HMA = {
    name: 'HMA $length',
    side: 'onchart',
    type: 'HMA',
    data: [],
    settings: {
        length: 10,
        applyto: `close`,
        lineWidth: 0.75,
        color: '#3af475ff',
    },
};
/////////////////////////////////////
const Ichi = {
    name: `Ichimoku Cloud`,
    side: 'onchart',
    type: 'Ichi',
    data: [],
    settings: {
        CP: 9,
        BP: 26,
        LSP: 52,
        DIZ: 26,
        baseColor: '#8D6E63FF',
        conversionColor: '#00E2FFFF',
        laggingColor: '#66CC66ff',
        lineWidth: 0.75,
        back1: '#79ff9e22',
        back2: '#ef535022',
    },
};
//////////////////////////////////////////////////////////////////////////////
const Ichimoku = {
    name: `Ichimoku`,
    side: 'onchart',
    type: 'Ichimoku',
    data: [],
    settings: {},
};
//
const KC = {
    name: 'KC $length $mult',
    side: 'onchart',
    type: 'KC',
    data: [],
    settings: {
        length: 20,
        mult: 1,
        showMid: true,
        use_tr: true,
        lineWidth: 0.75,
        color: '#4c8dffab',
        backColor: '#4c8dff0a',
    },
};
//
const KCW = {
    name: 'KCW $length $mult',
    side: 'offchart',
    type: 'KCW',
    data: [],
    settings: {
        length: 20,
        mult: 1,
        use_tr: true,
        lineWidth: 0.75,
        color: '#4c8dffab',
    },
};
//////////////////////////////////////////////////////////////
const LongShortTrades = {
    name: `LongShortTrades`,
    type: 'LongShortTrades',
    data: [],
    settings: {},
};
////////////////////////////////////////////////////////////color array
const MACD = {
    name: 'MACD $fast $slow $smooth',
    side: 'offchart',
    type: 'MACD',
    data: [],
    settings: {
        fast: 12,
        slow: 26,
        smooth: 9,
        histWidth: 4,
        macdWidth: 1,
        signalWidth: 1,
        defColor: '#42b28aff',
        macdColor: '#3782f2ff',
        signalColor: '#f48709ff',
        histColors: ['#35a776', '#79e0b3', '#e54150', '#ea969e'],
    },
};
/////// props.sett.color //////////////////////////////////////////////
const Markers = {
    name: `Markers`,
    side: 'onchart',
    type: 'Markers',
    data: [],
    settings: {
        //color: '#890c00',
    },
};
//
const MFI = {
    name: 'MFI $length',
    side: 'offchart',
    type: 'MFI',
    data: [],
    settings: {
        upper: 80,
        lower: 20,
        length: 14,
        lineWidth: 0.75,
        color: '#85c427ee',
        bandColor: '#aaaaaaff',
        backColor: '#85c42711',
    },
};
//
const MOM = {
    name: 'MOM $length',
    side: 'offchart',
    type: 'MOM',
    data: [],
    settings: {
        length: 11,
        lineWidth: 0.75,
        color: '#bcc427ee',
    },
};
//////////////////////////////////////////////
const PlotCross = {
    name: `PlotCross`,
    type: 'PlotCross',
    data: [],
    settings: {
        lineWidth: 2,
        color: ['#888888', '#42b28a', '#5691ce', '#612ff9', '#d50b90', '#ff2316'],
    },
};
//
const Ribbon = {
    name: 'EMA x $number',
    side: 'onchart',
    type: 'Ribbon',
    data: [],
    settings: {
        start: 10,
        number: 5,
        step: 10,
        lineWidth: 0.75,
        colors: ['#3aaaf4ee'],
    },
};
//
const ROC = {
    name: 'ROC $length',
    side: 'offchart',
    type: 'ROC',
    data: [],
    settings: {
        length: 9,
        lineWidth: 0.75,
        color: '#279fc4ff',
    },
};
//
const RSI = {
    name: 'RSI $length',
    side: 'offchart',
    type: 'RSI',
    data: [],
    settings: {
        length: 14,
        lineWidth: 0.75,
        color: '#ec206eff',
        bandColor: '#aaaaaaff',
        backColor: '#9b9ba316',
    },
};
//
const SAR = {
    name: 'SAR $start $inc $max',
    side: 'onchart',
    type: 'SAR',
    data: [],
    settings: {
        start: 0.02,
        inc: 0.02,
        max: 0.2,
        lineWidth: 2,
        color: '#35a9c6ff',
    },
};
//
const SMA = {
    name: 'SMA $length',
    side: 'onchart',
    type: 'SMA',
    data: [],
    settings: {
        length: 25,
        lineWidth: 0.75,
        color: '#d1385cff',
    },
};

const Stoch = {
    name: 'Stoch $param_k $param_d $smooth',
    side: 'offchart',
    type: 'Stoch',
    data: [],
    settings: {
        param_k: 14,
        param_d: 3,
        smooth: 3,
        lineWidth: 0.75,
        kColor: '#3782f2ff',
        dColor: '#f48709ff',
        bandColor: '#ddddddff',
        backColor: '#381e9c16',
    },
};

const SWMA = {
    name: 'SWMA',
    side: 'onchart',
    type: 'SWMA',
    data: [],
    settings: {
        lineWidth: 0.75,
        color: '#e57440ff',
    },
};
//////////////////////////////////////////////Positions?
const TradesPlus = {
    name: `TradesPlus`,
    type: 'TradesPlus',
    data: [],
    settings: {
        buyColor: '#63df89ff',
        sellColor: '#ec4662ff',
        labelColor: '#890c00ff',
    },
};
//
const TSI = {
    name: 'TSI $long $short $signal',
    side: 'offchart',
    type: 'TSI',
    data: [],
    settings: {
        long: 25,
        short: 13,
        signal: 13,
        lineWidth: 0.75,
        colors: ['#3bb3e4', '#f7046d'],
    },
};
//
const VWMA = {
    name: 'VWMA $length',
    side: 'onchart',
    type: 'VWMA',
    data: [],
    settings: {
        length: 20,
        lineWidth: 0.75,
        color: '#db0670ff',
    },
};
//
const WilliamsR = {
    name: '%R $length',
    side: 'offchart',
    type: 'WilliamsR',
    data: [],
    settings: {
        upper: -20,
        lower: -80,
        length: 14,
        lineWidth: 0.75,
        color: '#0980e8ff',
        bandColor: '#aaaaaaff',
        backColor: '#9b9ba316',
    },
};
/////////////////////////////////////////////////////
const XOhlcBars = {
    name: `XOhlcBars`,
    type: 'XOhlcBars',
    data: [],
    settings: {
        color: '#890c00ff',
    },
};

const params = {
    ALMA: ALMA,
    Area51: Area51,
    ATR: ATR,
    ATRp: ATRp,
    BB: BB,
    BBW: BBW,
    CCI: CCI,
    CMO: CMO,
    COG: COG,
    DHistogram: DHistogram,
    DMI: DMI,
    EMA: EMA,
    Histogram: Histogram,
    HMA: HMA,
    Ichi: Ichi,
    Ichimoku: Ichimoku,
    KC: KC,
    KCW: KCW,
    LongShortTrades: LongShortTrades,
    MACD: MACD,
    Markers: Markers,
    MFI: MFI,
    MOM: MOM,
    PlotCross: PlotCross,
    Ribbon: Ribbon,
    ROC: ROC,
    RSI: RSI,
    SAR: SAR,
    SMA: SMA,
    Stoch: Stoch,
    SWMA: SWMA,
    TradesPlus: TradesPlus,
    TSI: TSI,
    VWMA: VWMA,
    WilliamsR: WilliamsR,
    XOhlcBars: XOhlcBars,
};

export default params;
